import type { PlanApi } from "@/Modules/Models/Api/Plan";
import type { GetPlansApiQuery, PostPlanToPatientApiQuery } from "@/Modules/Models/Api/Plan";
import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import { get2, post2 } from "./utils/FunctionalTherapyApi";

export async function getPlan(planUuid: string): Promise<PlanApi> {
  return get2<void, PlanApi>(`v2.0/plans/${planUuid}`);
}

export function getPlans(getPlansApiQuery: GetPlansApiQuery): Promise<PaginatedApiResponse<PlanApi>> {
  return get2<GetPlansApiQuery, PaginatedApiResponse<PlanApi>>("/v3.0/plans", getPlansApiQuery, undefined, {
    raw: true,
  });
}

export function postPlanToPatient(infoPostPlan: PostPlanToPatientApiQuery): Promise<void> {
  return post2<PostPlanToPatientApiQuery, void>("/v1.0/plans/private", infoPostPlan);
}
